module.exports = __webpack_public_path__ + "static/media/Seine River.a264b0fc.jpg";